import { render, staticRenderFns } from "./ProductService.vue?vue&type=template&id=5c639e04&scoped=true&"
import script from "./ProductService.vue?vue&type=script&lang=js&"
export * from "./ProductService.vue?vue&type=script&lang=js&"
import style0 from "./ProductService.vue?vue&type=style&index=0&id=5c639e04&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c639e04",
  null
  
)

export default component.exports